import { Button, Divider, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconKey } from "@tabler/icons-react";
import AuthFieldForm from "src/components/pages/Settings/AuthFieldForm";
import { useCheckPerm } from "src/hooks";

interface Props {
  userId: string;
}

const SetCredentialsButton = ({ userId }: Props) => {
  const [opened, { open, close }] = useDisclosure(false);
  const checkPerm = useCheckPerm();
  const authFieldFormStyles = {
    border: "none",
    background: "none",
    boxShadow: "none",
  };

  if (
    !checkPerm("changepin") &&
    !checkPerm("changepassword") &&
    !checkPerm("changepassphrase")
  ) {
    return <></>;
  }

  return (
    <>
      <Button
        leftSection={<IconKey size={"1.4rem"} />}
        variant="outline"
        onClick={open}>
        Set credentials
      </Button>
      <Modal opened={opened} onClose={close} title="User Credentials">
        {checkPerm("changepin") && (
          <AuthFieldForm
            userId={userId}
            type="pin"
            style={authFieldFormStyles}
            minLength={4}
            maxLength={4}
          />
        )}
        <Divider my="sm" />
        {checkPerm("changepassword") && (
          <AuthFieldForm
            userId={userId}
            type="password"
            style={authFieldFormStyles}
            minLength={8}
            maxLength={30}
          />
        )}
        <Divider my="sm" />
        {checkPerm("changepassphrase") && (
          <AuthFieldForm
            userId={userId}
            type="passphrase"
            style={authFieldFormStyles}
          />
        )}
      </Modal>
    </>
  );
};

export default SetCredentialsButton;
